"use client";

export function A2PForm() {
  return (
    <iframe
      title="Enterprise A2P Form"
      src="https://embed.sendhelios.com/uoqjn50oxz3rh567"
      style={{
        border: "none",
        width: "100%",
        height: "1200px",
        overflow: "hidden",
      }}
    />
  );
}
